export const HoleRectImg = require("@/commons/images/hole-rect.png");
export const HoleCircleImg = require("@/commons/images/hole-circle.png");
export const WallHeightImg = require("@/commons/images/wall-height.png");
export const WallWidthImg = require("@/commons/images/wall-width.png");
export const DoorImg = require("@/commons/images/door.png");
export const WindowImg = require("@/commons/images/window.png");
